export const BILLING_MODE_LOADING = "billing-mode/loading";
export const BILLING_MODE_ERROR = "billing-mode/error";
export const BILLING_MODE_LIST = "billing-mode/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/billing-mode-tariff/constants.js